export default __webpack_public_path__ + "static/media/auth-bg.d9743887.png";